import React from 'react';
import { CircularProgress } from '@mui/material';

const InLoading = () => (
  <div style={{
    width:'100%',height:'80px',
    background: 'rgba(255, 255, 255, .5)',display:'flex',justifyContent:'center',alignItems:'center'
  }}>
    <CircularProgress thickness={4} size={24}
      style={{

      }}
    />
  </div>
);

export default InLoading;
